import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/use-auth';
import { tierFromProductId } from '@/lib/stripe-tiers';

export interface SubscriptionStatus {
  subscribed: boolean;
  product_id: string | null;
  subscription_end: string | null;
  /** Resolved tier based on the Stripe product */
  tier: 'free' | 'pro' | 'enterprise';
}

export function useSubscription() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['subscription', user?.id],
    queryFn: async (): Promise<SubscriptionStatus> => {
      const { data, error } = await supabase.functions.invoke('check-subscription');
      if (error) throw error;
      const raw = data as { subscribed: boolean; product_id: string | null; subscription_end: string | null };
      return {
        ...raw,
        tier: raw.subscribed ? tierFromProductId(raw.product_id) : 'free',
      };
    },
    enabled: !!user,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
